import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import './stylesheets/App.css';
import Home from './screens/Home';
import Cart from './screens/Cart';
import Country from './screens/ProductsFilter';
import Navbar from './components/Navbar';
import NotFound from './screens/NotFound';
import ProductScreen from './screens/ProductScreen';


import {connect} from 'react-redux';
import {removeItemFromCart, removeAllItemsFromCart} from './ReduxActions/CartActions';

import CartTimePopup from './components/CartTimePopup.js';


const Countries = (match) => (
    <Switch>
    <Route path={`/country/:country`} component={Country} />
    <Route component={NotFound} />
    </Switch>
)

const Products = (match) => (
  <Switch>
    <Route path={'/product/:id'} component={ProductScreen} />
  </Switch>

)


class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      info: undefined,
      currentTime: '',
      timeDiff: '',
      openTimer: false
    }
  }

  componentDidMount() {
    // this.props.dispatchRemoveAllItemsFromCart(this.props.Auth.sessionId); // remove all items from cart
    
    // If items are in the cart open up the cart countdown
    if (this.props.Cart.items) {
      this.getCartTime();
    }
  }

  getCartTime() {
    this.setState({
      timeDiff : new Date() - new Date(this.props.Cart.date),
      openTimer: true
    })
  }

  render() {
    console.log(this.state.timeDiff);

    const CartItemTimer = () => {
      if (this.state.timeDiff) {
        return (
          <CartTimePopup openTimer={true} handleCartTimerClose={this.handleCartTimerClose} cartDate={this.props.Cart.date} />
        )
      }
      return null;
  
    }

    const App = () => (
      <div>
        <Navbar/>
        <Switch>
          <Route exact path='/' component={Home}/>
          <Route path='/country' component={Countries} />
          <Route path='/product' component={Products} />
          <Route exact path='/cart' component={Cart} />
          <Route component={NotFound} />
        </Switch>
        <CartItemTimer />
      </div>
    )
    return (
      <Switch>
        <App/>
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth,
    Cart: state.Cart
  }
}

const mapDispatchToProps = {
  dispatchRemoveFromCart: (product) => removeItemFromCart(product),
  dispatchRemoveAllItemsFromCart: (sessionId) => removeAllItemsFromCart(sessionId)
}


export default connect(mapStateToProps, mapDispatchToProps)(App);


/*
import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
        </header>
      </div>
    );
  }
}

export default App;
*/